'use client';
import Icon from '../Icon';
import { programs } from '@/lib/vster/data';

interface Props {
  navigate: (s: string) => void;
  navigatePlanner: (idx: number) => void;
}

export default function DetailScreen({ navigate, navigatePlanner }: Props) {
  const featured = programs.slice(0, 3);

  return (
    <main style={{ maxWidth: 1280, margin: '0 auto', padding: '28px 24px 80px', animation: 'vfade .4s ease' }}>
      {/* 빵크럼 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontFamily: "'JetBrains Mono',monospace", fontSize: 12, color: '#737685', marginBottom: 18 }}>
        <button onClick={() => navigate('home')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#737685', fontFamily: 'inherit', fontSize: 12, padding: 0 }}>홈</button>
        <Icon name="chevron_right" size={15} />
        <button onClick={() => navigate('list')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#737685', fontFamily: 'inherit', fontSize: 12, padding: 0 }}>지원사업</button>
        <Icon name="chevron_right" size={15} />
        <span style={{ color: '#051a3e', fontWeight: 600 }}>창업성장기술개발사업</span>
      </div>

      {/* 헤더 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, flexWrap: 'wrap', marginBottom: 18 }}>
        <div style={{ maxWidth: 760 }}>
          <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
            <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, padding: '4px 10px', borderRadius: 6, background: '#e9edff', color: '#003d9b' }}>중소벤처24</span>
            <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, padding: '4px 10px', borderRadius: 6, background: '#f1f3ff', color: '#434654' }}>R&D</span>
          </div>
          <h1 className="vh2" style={{ fontSize: 32, fontWeight: 700, letterSpacing: '-.015em', lineHeight: 1.2, margin: '0 0 8px' }}>2026년 창업성장기술개발사업 (디딤돌 R&D)</h1>
          <p style={{ fontSize: 17, color: '#434654', margin: 0 }}>창업 7년 이내 중소기업의 혁신 기술 시제품 개발과 사업화를 지원하는 국가 R&D 과제입니다.</p>
        </div>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: '#fff', border: '1px solid #ffdad6', color: '#ba1a1a', padding: '8px 14px', borderRadius: 999, fontFamily: "'JetBrains Mono',monospace", fontSize: 13, fontWeight: 600, flexShrink: 0 }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ba1a1a', display: 'inline-block' }} />접수 마감 임박
        </span>
      </div>

      {/* 통계 카드 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 14, marginBottom: 28 }}>
        {[
          { icon: 'payments', color: '#003d9b', label: '총 예산', value: '1,200억원' },
          { icon: 'target', color: '#00687b', label: '지원 한도', value: '최대 1.2억원' },
          { icon: 'groups', color: '#003d9b', label: '지원 대상', value: '창업 7년 이내' },
          { icon: 'schedule', color: '#ba1a1a', label: '마감 기한', value: '06.19 · D-1', valueColor: '#ba1a1a' },
        ].map((s, i) => (
          <div key={i} style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 14, padding: 18, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Icon name={s.icon} size={22} color={s.color} />
            <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, color: '#737685' }}>{s.label}</span>
            <span style={{ fontSize: 22, fontWeight: 700, color: s.valueColor }}>{s.value}</span>
          </div>
        ))}
      </div>

      <div className="vstack-sm" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,2fr) minmax(300px,1fr)', gap: 24, alignItems: 'start' }}>
        {/* 본문 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {/* 탭 */}
          <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #e4e8f6', overflowX: 'auto' }}>
            {['사업 개요', '지원 자격', '신청 방법', '제출 서류', '자주 묻는 질문'].map((t, i) => (
              <span key={t} style={{ padding: '12px 16px', fontSize: 14, fontWeight: i === 0 ? 700 : 400, color: i === 0 ? '#003d9b' : '#434654', borderBottom: i === 0 ? '2px solid #003d9b' : 'none', whiteSpace: 'nowrap', cursor: 'pointer' }}>{t}</span>
            ))}
          </div>

          {/* AI 요약 */}
          <div style={{ background: '#f1f3ff', border: '1px solid #d8e2ff', borderRadius: 14, padding: 20, position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 4, background: '#003d9b' }} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
              <Icon name="auto_awesome" size={22} color="#003d9b" fill={1} />
              <h3 style={{ fontSize: 17, fontWeight: 700, margin: 0 }}>AI 3줄 요약</h3>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 11, color: '#737685', background: '#fff', padding: '3px 8px', borderRadius: 6, marginLeft: 'auto' }}>공고문 자동 분석</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { icon: 'check_circle', color: '#1f8a5b', text: <><strong>지원조건</strong> · 창업 7년 이내, 전년도 매출 20억원 미만 중소기업. 기업부설연구소 또는 연구개발전담부서 보유 권장.</> },
                { icon: 'payments', color: '#003d9b', text: <><strong>지원금액</strong> · 최대 1.2억원 (정부지원 80% + 자부담 20%), 개발기간 최대 12개월.</> },
                { icon: 'description', color: '#854d0e', text: <><strong>핵심서류</strong> · 사업계획서, 사업자등록증, 최근 2년 재무제표, 연구개발 인력 현황표.</> },
              ].map((row, i) => (
                <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                  <Icon name={row.icon} size={20} color={row.color} fill={1} />
                  <span style={{ fontSize: 15, lineHeight: 1.5, color: '#1d3054' }}>{row.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 사업 목적 */}
          <div style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 14, padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
            <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>사업 목적</h2>
            <p style={{ fontSize: 15, lineHeight: 1.65, color: '#434654', margin: 0 }}>창업성장기술개발사업은 성장 잠재력을 갖춘 창업기업의 기술개발을 지원하여 기술기반 창업기업의 혁신성장을 촉진합니다.</p>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: '8px 0 0' }}>주요 지원 내용</h3>
            {[
              { title: '기술개발 자금', desc: '시제품 제작·시험·인증에 필요한 직접비 및 간접비 지원.' },
              { title: '사업화 연계', desc: '후속 사업화 자금 및 투자 연계 프로그램 우선 추천.' },
              { title: '전담 멘토링', desc: '기술·경영 전문가의 과제 수행 컨설팅 제공.' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                <Icon name="check" size={20} color="#00687b" style={{ marginTop: 1 }} />
                <span style={{ fontSize: 15, lineHeight: 1.5, color: '#434654' }}><strong style={{ color: '#051a3e' }}>{item.title}</strong> · {item.desc}</span>
              </div>
            ))}
          </div>

          {/* 플래너 배너 */}
          <div style={{ background: '#003d9b', borderRadius: 14, padding: 22, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <span style={{ width: 46, height: 46, borderRadius: 12, background: 'rgba(255,255,255,.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon name="calendar_month" size={26} color="#50dcff" />
              </span>
              <div>
                <div style={{ fontSize: 17, fontWeight: 700, color: '#fff' }}>마감 역산 플래너로 일정 관리</div>
                <div style={{ fontSize: 14, color: '#dae2ff' }}>D-1까지 할 일을 자동으로 타임라인에 배치합니다.</div>
              </div>
            </div>
            <button onClick={() => navigatePlanner(1)} style={{ background: '#fff', color: '#003d9b', border: 'none', cursor: 'pointer', padding: '12px 22px', borderRadius: 10, fontSize: 15, fontWeight: 600, flexShrink: 0 }}>일정 추가하기</button>
          </div>
        </div>

        {/* 사이드바 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, position: 'sticky', top: 88 }}>
          {/* 신청 카드 */}
          <div style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 16, padding: 20, display: 'flex', flexDirection: 'column', gap: 14, boxShadow: '0 8px 28px rgba(5,26,62,.07)', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: 'linear-gradient(90deg,#003d9b,#00687b)' }} />
            <div>
              <div style={{ fontSize: 18, fontWeight: 700 }}>지금 바로 신청하세요</div>
              <div style={{ fontSize: 14, color: '#434654', marginTop: 2 }}>마감 전 제출해야 이번 회차에 평가됩니다.</div>
            </div>
            <div style={{ background: '#fff5f5', border: '1px solid #ffdad6', borderRadius: 10, padding: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 7, color: '#ba1a1a', fontWeight: 700, fontSize: 15 }}><Icon name="timer" size={20} fill={1} />1일 남음</span>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 13, color: '#737685' }}>06.19 마감</span>
            </div>
            <button style={{ width: '100%', background: '#003d9b', color: '#fff', border: 'none', cursor: 'pointer', padding: 14, borderRadius: 11, fontSize: 16, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
              신청 페이지로 이동<Icon name="arrow_forward" size={18} color="#fff" />
            </button>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => navigate('kanban')} style={{ flex: 1, background: '#e9edff', color: '#003d9b', border: 'none', cursor: 'pointer', padding: 11, borderRadius: 10, fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }}>
                <Icon name="add_task" size={18} />트래킹
              </button>
              <button style={{ flex: 1, background: '#e9edff', color: '#003d9b', border: 'none', cursor: 'pointer', padding: 11, borderRadius: 10, fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }}>
                <Icon name="bookmark" size={18} />저장
              </button>
            </div>
          </div>

          {/* 자가진단 */}
          <div style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 16, padding: 20, display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid #eef1fb', paddingBottom: 12 }}>
              <Icon name="fact_check" size={21} color="#00687b" fill={1} />
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>자격 자가진단</h3>
            </div>
            {[
              { label: '창업 7년 이내의 중소기업입니까?', checked: true },
              { label: '전년도 매출이 20억원 미만입니까?', checked: true },
              { label: '기업부설연구소 또는 전담부서를 보유했습니까?', checked: false },
            ].map((item, i) => (
              <label key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 9, fontSize: 14, lineHeight: 1.4, color: '#434654', cursor: 'pointer' }}>
                <span style={{ width: 18, height: 18, borderRadius: 5, background: item.checked ? '#003d9b' : 'none', border: item.checked ? 'none' : '1.5px solid #c3c6d6', flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginTop: 1 }}>
                  {item.checked && <Icon name="check" size={14} color="#fff" fill={1} />}
                </span>
                {item.label}
              </label>
            ))}
            <div style={{ background: '#d6f0e2', borderRadius: 10, padding: 12, display: 'flex', alignItems: 'flex-start', gap: 9 }}>
              <Icon name="verified" size={20} color="#10663f" fill={1} />
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#10663f' }}>지원 가능성 높음</div>
                <div style={{ fontSize: 13, color: '#10663f', marginTop: 2 }}>핵심 요건을 충족합니다. 연구소 미보유 시 가점만 일부 제외됩니다.</div>
              </div>
            </div>
          </div>

          {/* 챗봇 */}
          <div style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 16, padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Icon name="forum" size={21} color="#003d9b" fill={1} />
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>공고문 챗봇</h3>
            </div>
            <div style={{ background: '#f1f3ff', borderRadius: '12px 12px 12px 4px', padding: 12, fontSize: 14, lineHeight: 1.5, color: '#1d3054' }}>
              네, 지원 가능합니다. 귀사는 창업 3년차 법인으로 <strong>창업 7년 이내</strong> 요건을 충족합니다.
              <div style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 11, color: '#737685', marginTop: 8, display: 'flex', alignItems: 'center', gap: 5 }}>
                <Icon name="description" size={14} />공고문 4p · 지원자격 항목 기준
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {['나 지원 가능해?', '서류 뭐 필요해?', '얼마 받아?'].map(q => (
                <span key={q} style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, background: '#e9edff', color: '#003d9b', padding: '6px 11px', borderRadius: 999 }}>{q}</span>
              ))}
            </div>
            <div style={{ position: 'relative' }}>
              <input placeholder="공고문에 대해 물어보세요" style={{ width: '100%', padding: '11px 42px 11px 14px', border: '1px solid #c3c6d6', borderRadius: 11, fontFamily: 'inherit', fontSize: 14, outline: 'none' }} />
              <span style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', width: 30, height: 30, borderRadius: 8, background: '#003d9b', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon name="send" size={18} color="#fff" />
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* 연관 공고 */}
      <section style={{ marginTop: 48 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e4e8f6', paddingBottom: 14, marginBottom: 20 }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>연관 지원사업</h2>
          <button onClick={() => navigate('list')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#003d9b', fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>전체 보기<Icon name="arrow_forward" size={18} /></button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(290px,1fr))', gap: 16 }}>
          {featured.map((p, i) => (
            <div key={i} onClick={() => navigate('detail')} style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 14, padding: 18, display: 'flex', flexDirection: 'column', gap: 10, cursor: 'pointer', boxShadow: '0 2px 12px rgba(5,26,62,.03)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, color: '#005f71', background: '#50dcff', padding: '4px 10px', borderRadius: 999 }}>{p.match} 일치</span>
                <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, padding: '3px 9px', borderRadius: 6, background: p.ddBg, color: p.ddColor }}>{p.dday}</span>
              </div>
              <h3 style={{ fontSize: 17, fontWeight: 600, lineHeight: 1.3, margin: '2px 0 0' }}>{p.title}</h3>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, color: '#737685' }}>{p.org}</span>
              <span style={{ fontSize: 16, fontWeight: 700, color: '#003d9b', marginTop: 'auto' }}>{p.amount}</span>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
